import { featureArticles } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";
import RankingBoard from "@/pages/home/components/RankingBoard";

export default function FeedSection() {
  const [lead, ...rest] = featureArticles;
  const gridItems = rest.slice(0, 4);
  const wide = rest[4];

  return (
    <section id="feed" className="border-b border-background-200/70">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          index="01"
          eyebrow="Latest Feed"
          title="最新动漫资讯"
          desc="新番情报、作品评测与情报速报汇集于此，按发布时间倒序更新，点开即可了解作品全貌。"
          actionLabel="查看全部资讯"
          actionHref="#feed"
        />

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,2fr)_minmax(0,1fr)]">
          {/* feed column */}
          <div>
            {/* lead article */}
            <article className="group cursor-pointer">
              <figure className="relative overflow-hidden rounded-lg bg-background-100">
                <div className="relative h-[280px] w-full sm:h-[340px]">
                  <img
                    src={lead.image}
                    alt={lead.alt}
                    title={`${lead.title} · 动漫资讯`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent"></div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
                  <div className="mb-3 flex flex-wrap items-center gap-2">
                    <span className="rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-foreground-950">
                      {lead.tag}
                    </span>
                    <span className="rounded-full border border-background-50/40 px-2.5 py-1 text-xs text-background-100">
                      {lead.no}
                    </span>
                  </div>
                  <h3 className="max-w-2xl font-heading text-xl leading-snug font-bold text-background-50 md:text-2xl">
                    {lead.title}
                  </h3>
                  <p className="mt-2 hidden max-w-xl text-sm leading-6 text-background-100/90 sm:block">
                    {lead.excerpt}
                  </p>
                </div>
              </figure>
              <p className="mt-3 text-xs text-foreground-500">{lead.meta}</p>
            </article>

            {/* grid articles */}
            <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2">
              {gridItems.map((item) => (
                <article key={item.id} className="group cursor-pointer">
                  <figure className="relative overflow-hidden rounded-lg bg-background-100">
                    <div className="relative h-44 w-full">
                      <img
                        src={item.image}
                        alt={item.alt}
                        title={`${item.title} · 动漫资讯`}
                        className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
                      />
                    </div>
                    <span className="absolute top-3 left-3 rounded-full bg-background-50/95 px-2.5 py-1 text-xs font-medium text-foreground-900">
                      {item.tag}
                    </span>
                  </figure>
                  <h3 className="mt-3 font-heading text-base leading-snug font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                    {item.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">
                    {item.excerpt}
                  </p>
                  <p className="mt-2 text-xs text-foreground-500">{item.meta}</p>
                </article>
              ))}
            </div>

            {/* wide article */}
            <article className="group mt-8 cursor-pointer">
              <div className="flex flex-col gap-4 overflow-hidden rounded-lg border border-background-200/70 bg-background-100/50 sm:flex-row">
                <figure className="relative h-48 w-full shrink-0 bg-background-200 sm:h-auto sm:w-64">
                  <img
                    src={wide.image}
                    alt={wide.alt}
                    title={`${wide.title} · 动漫评测`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
                  />
                </figure>
                <div className="flex flex-1 flex-col justify-center p-5">
                  <div className="mb-2 flex items-center gap-2">
                    <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
                      {wide.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{wide.meta}</span>
                  </div>
                  <h3 className="font-heading text-lg leading-snug font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                    {wide.title}
                  </h3>
                  <p className="mt-2 text-sm leading-6 text-foreground-600">{wide.excerpt}</p>
                </div>
              </div>
            </article>
          </div>

          {/* ranking sidebar */}
          <div className="lg:pl-2">
            <RankingSlot />
          </div>
        </div>
      </div>
    </section>
  );
}

function RankingSlot() {
  return (
    <div id="ranking" className="lg:sticky lg:top-24">
      <RankingBoard />
    </div>
  );
}